<script setup>
import { authStore } from '@/store/auth'
import { useGeneralStore } from '@/store/GeneralStore'
import defaultAvatar from '@images/avatars/default-profile.jpg'
import { PerfectScrollbar } from 'vue3-perfect-scrollbar'

const router = useRouter()

const { data } = storeToRefs(authStore())
const { signOut } = authStore()
const { cleanCities } = useGeneralStore()

const logout = async () => {
  try {
    cleanCities()
    await signOut()
  }
  catch (error) {
    throw createError(error)
  }
}

const userProfileList = [
  { type: 'divider' },

  /*{
    type: 'navItem',
    icon: 'tabler-user',
    title: 'Profile',
    to: {
      name: '/profile/cv',
      params: { id: 21 },
    },
  },*/
  {
    type: 'navItem',
    icon: 'tabler-settings',
    title: useNuxtApp().$i18n.t('profile'),
    to: {
      name: 'profile-settings-tab',
      params: { tab: 'account' },
    },
  },

  /*{
    type: 'navItem',
    icon: 'tabler-credit-card',
    title: 'Billing',
    to: {
      name: 'pages-account-settings-tab',
      params: { tab: 'billing-plans' },
    },
    badgeProps: {
      color: 'error',
      content: '3',
    },
  },*/
  { type: 'divider' },
  {
    type: 'navItem',
    icon: useNuxtApp().$i18n.t('finance_icon'),
    title: useNuxtApp().$i18n.t('finance'),
    to: { path: '/finance/my' },
  },
  {
    type: 'navItem',
    icon: useNuxtApp().$i18n.t('agenda_icon'),
    title: useNuxtApp().$i18n.t('agenda'),
    to: { path: '/agenda' },
  },
  {
    type: 'navItem',
    icon: useNuxtApp().$i18n.t('myIncidents_icon'),
    title: useNuxtApp().$i18n.t('myIncidents'),
    to: { path: '/incidents/my' },
  },
  {
    type: 'navItem',
    href: 'https://outlook.office.com/owa/?realm=ieflafloresta.edu.co',
    icon: 'tabler-at',
    title: useNuxtApp().$i18n.t('email_link'),
    target: '_blank',
    external: true,
  },
  { type: 'divider' },
  {
    type: 'navItem',
    icon: useNuxtApp().$i18n.t('circulares_icon'),
    title: useNuxtApp().$i18n.t('circulares_link'),
    to: { path: '/circulares' },
  },

  /*{
    type: 'navItem',
    icon: useNuxtApp().$i18n.t('mySchedule_icon'),
    title: useNuxtApp().$i18n.t('mySchedule'),
    to: { path: '/schedule/my' },
  },*/
  {
    type: 'navItem',
    icon: useNuxtApp().$i18n.t('rules_icon'),
    title: useNuxtApp().$i18n.t('rules_link'),
    to: { path: '/rules/manual' },
  },
  { type: 'divider' },
  {
    type: 'navItem',
    icon: 'tabler-logout',
    title: useNuxtApp().$i18n.t('Close'),
    onClick: logout,
  },
]
</script>

<template>
  <VBadge
    v-if="data"
    dot
    bordered
    location="bottom right"
    offset-x="3"
    offset-y="3"
    color="success"
  >
    <VAvatar
      class="cursor-pointer"
      :color="!(data && data.user) ? 'primary' : undefined"
      :variant="!(data && data.user) ? 'tonal' : undefined"
    >
      <VImg :src="data.user.FILE_url">
        <template #error>
          <VImg
            alt="user-profile"
            :src="defaultAvatar"
          />
        </template>
      </VImg>
    </VAvatar>
    <!-- SECTION Menu -->
    <VMenu
      activator="parent"
      width="230"
      location="bottom end"
      offset="14px"
    >
      <VList>
        <VListItem>
          <template #prepend>
            <VListItemAction start>
              <VBadge
                dot
                location="bottom right"
                offset-x="3"
                offset-y="3"
                color="success"
                bordered
              >
                <VAvatar
                  :color="!(data && data.user.FILE_url) ? 'primary' : undefined"
                  :variant="!(data && data.user.FILE_url) ? 'tonal' : undefined"
                >
                  <VImg :src="data.user.FILE_url">
                    <template #error>
                      <VImg
                        alt="user-profile"
                        :src="defaultAvatar"
                      />
                    </template>
                  </VImg>
                </VAvatar>
              </VBadge>
            </VListItemAction>
          </template>

          <VListItemTitle class="font-weight-medium">
            {{ data.user?.PRFL_names }}
          </VListItemTitle>
          <VListItemSubtitle>{{ data.user?.PRFL_lastnames }}</VListItemSubtitle>
        </VListItem>

        <PerfectScrollbar :options="{ wheelPropagation: false }">
          <template
            v-for="item in userProfileList"
            :key="item.title"
          >
            <VListItem
              v-if="item.type === 'navItem'"
              :to="item.to"
              :href="item.href"
              :target="item.target"
              @click="item.onClick && item.onClick()"
            >
              <template #prepend>
                <VIcon
                  class="me-2"
                  :icon="item.icon"
                  size="22"
                />
              </template>

              <VListItemTitle>{{ item.title }}</VListItemTitle>

              <template
                v-if="item.badgeProps"
                #append
              >
                <VBadge v-bind="item.badgeProps" />
              </template>
            </VListItem>

            <VDivider
              v-else
              class="my-2"
            />
          </template>
        </PerfectScrollbar>
      </VList>
    </VMenu>
    <!-- !SECTION -->
  </VBadge>
</template>
